/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierPlanLookup.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/carrier-plan-lookup";

export class AutogenModelCarrierPlanLookup<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierPlanLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierPlanLookup extends ModelRow<RowCarrierPlanLookupFields> {
	constructor(values?: Partial<RowCarrierPlanLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierPlanLookupFields {
	company_id: string;
	descr: string;
	id: string;
	type_of: string;
}

